export default {
  DotcomHeaderMobileLoginPrompt__BODY: "Log in to Rapid Rewards and earn points on your next trip.",
  DotcomHeaderMobileLoginPrompt__TITLE: "HAVE AN ACCOUNT?",
};
